import axios from 'axios';
// import errCheck from '../API/UserService';
export const errCheck = (err) => {
    if(err.response.data.statusCode=='401'){
        localStorage.removeItem("token");
        window.location.href = '/login';
    }
};
export default class CouponService {
    async getCouponList(cCode, cTitle, sdate, edate) {
        return await axios
            .post(`/coupon/all`, {
                coupon_code: cCode,
                coupon_title: cTitle,
                start_date: sdate,
                end_date: edate,
            })
            .then((res) => res.data.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async getExcel(cpn_code, cTitle, sdate, edate,dreason) {
        return await axios({
            url: `/coupon/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                coupon_code: cpn_code,
                coupon_title: cTitle,
                start_date: sdate,
                end_date: edate,
                reason:dreason,
            },
        }).then((res) => res)
        .catch((err) => {
            errCheck(err);
        });
    }
    async couponDetails(ids) {
        return await axios
            .get(`/coupon/${ids}`)
            .then((res) => res.data.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async assignCouponList(ids) {
        return await axios
            .post(`/coupon/assign_coupon_user`, {
                coupon_id:ids
            })
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async assignUser(datas) {
        return await axios
            .post(`/coupon/assign_coupon`, datas)
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
}
